import doc                                 from '@widesk-core/decorators/doc';
import AbstractPushNotificationStatusModel from './AbstractPushNotificationStatusModel';
import model                               from '@widesk-core/decorators/model';

@doc.urnResource('push_notification_status')
@model.cacheDuration()
export default class PushNotificationStatusModel extends AbstractPushNotificationStatusModel {
	get color() {
		switch (this.reference) {
			case 'PLANNED':
				return 'processing';
			case 'TO_SEND':
				return 'warning';
			case 'SENT':
				return 'success';
			case 'ARCHIVED':
				return 'default';
		}
	}
}
